export const primary = "#1565c0" //"#1976d2"